import e from"styled-components";import{theme as r}from"../../../theme.js";const t=i=>{switch(i){case"circle":return"50%";default:return`${r.radius}px`}},o=e.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({backgroundColor:i})=>i};
  width: ${({size:i})=>i};
  height: ${({size:i})=>i};
  border-radius: ${({varinat:i})=>t(i)};
  > svg {
    width: ${({iconSize:i})=>i};
    height: ${({iconSize:i})=>i};
    > g,
    path,
    cirlce {
      fill: ${({color:i})=>i};
    }
  }
`;export{o as Container};
